import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors) => ({
  // Fullscreen: fill the screen; inner block centers, button sits below at bottom.
  centeredContent: {
    flex: 1,
    paddingHorizontal: theme.spacing[5],
    paddingBottom: theme.spacing[5],
  },
  // BottomSheet: natural height, content stacked with the button below.
  flowContent: {
    paddingHorizontal: theme.spacing[5],
  },
  // The avatar/heading/stars block. Grows to fill in fullscreen (pushing the
  // button to the bottom), natural height in the sheet.
  contentBlock: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  contentBlockPinned: {
    flex: 1,
  },
  avatarContainer: {
    marginBottom: theme.spacing[5],
    backgroundColor: colors.backgroundL1,
  },
  mainHeading: {
    textAlign: 'center',
    marginVertical: theme.spacing[3],
    paddingHorizontal: theme.spacing[12],
  },
  dateText: {
    textAlign: 'center',
    marginBottom: theme.spacing[6],
  },
  starsContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginVertical: theme.spacing[5],
  },
  starButton: {
    padding: theme.spacing[2],
    marginHorizontal: -theme.spacing[3],
  },
  // In-flow, full-width action button (both variants).
  actionButton: {
    alignSelf: 'stretch',
    marginTop: theme.spacing[5],
  },
}));
